<template>
  <ModalHolder :title="''" m-top="120" m-width="30%" m-height="35vh" :is-show="isShow">
    <template slot="mheader">
      <div v-if="notification" style="height: 20px;">
        <span style="position:absolute;right:15px;top:15px" @click="dismissModal()">
          <Icon size="20" type="close-circled"></Icon>
        </span>
        <strong>{{notification.item_name}}</strong>
      </div>
    </template>
    <template slot="mcontent" style="display: flex;">
      <div style="display: flex; width: 100%; height: 100%; flex-direction: column;">
        <p align="center" style="display: flex; justify-content: center; align-items: center;">
          <img
            v-if="ownerInfo"
            style="width:50%; max-width: 150px;"
            :src="userDisplayImage(ownerInfo)"
          />
        </p>
        <h4
          v-if="notification && notification.type == 'private_journal_invite'"
          align="center"
          style="height: 50%; margin-top: 20px;"
        >
          <div v-if="!isAccepted">
            <p>You have been invited to join</p>
            <p>{{notification.more_data.from_uname}}'s</p>
            <p>care team.</p>
          </div>
          <div v-else>
            <p>You have already accepted this invitation</p>
          </div>
        </h4>
        <h4
          style="height: 35%; display: flex; align-items: center; justify-content: center"
          v-else
          align="center"
        >{{ (notification && notification.message) ? notification.message : "New Notification"}}</h4>
      </div>
    </template>
    <template slot="mfooter">
      <div v-if="!isAccepted">
        <Button type="error" style="float: left;" @click="rejectInvite()">Decline</Button>
        <Button type="primary" @click="acceptInvite()">Accept</Button>
      </div>
      <div v-else>
        <Button @click="goToProfile()">Show Profile</Button>
      </div>
    </template>
  </ModalHolder>
</template>

<script>
import ModalHolder from "@/components/ModalHolderComponent";
import Utils from "@/utils.js";
import _ from "lodash";

export default {
  name: "NotificationModal",
  data() {
    return {
      ownerInfo: null
    };
  },
  computed: {
    isAccepted() {
      return _.get(this.notification, "more_data.is_accepted", false);
    },
    isShow() {
      return this.$store.state.notification.modal.show;
    },
    notification() {
      return this.$store.state.notification.modal.notification;
    }
  },
  watch: {
    isShow(n, o) {
      if (n) {
        this.$store
          .dispatch("careteam/getCareTeamOwner", {
            id: this.notification.more_data.from_uid
          })
          .then(res => {
            this.ownerInfo = res;
          });
      }
    }
  },
  methods: {
    acceptInvite() {
      this.$emit("accept", this.notification);
    },
    rejectInvite() {
      this.$emit("reject", this.notification);
    },
    dismissModal() {
      this.$emit("close");
    },
    userDisplayImage(user) {
      return Utils.getDisplayImage("user", user, "medium");
    },
    goToProfile() {
      this.dismissModal()
      this.$router.push(`/profile/${this.notification.more_data.from_uid}`)
    }
  },
  components: {
    ModalHolder
  }
};
</script>